import { useSyncExternalStore } from 'react';
import { breakpoints } from '@zep-us/zus/tokens';

// NoticeCard 가 모바일 변형(하단 전폭)으로 바뀌는 기준과 같은 미디어 쿼리.
const COMPACT_QUERY = `(max-width: ${breakpoints.tabletLg}px)`;

const subscribe = (onChange: () => void) => {
  const mql = window.matchMedia(COMPACT_QUERY);
  mql.addEventListener('change', onChange);
  return () => mql.removeEventListener('change', onChange);
};

/** 창 폭이 카드의 모바일 분기에 걸리는지. 창 크기 변경도 반영한다. */
export function useIsCompactViewport(): boolean {
  return useSyncExternalStore(
    subscribe,
    () => window.matchMedia(COMPACT_QUERY).matches,
    () => false,
  );
}
